import "./App.scss";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/common/Header/Header";
import Footer from "./components/common/Footer/Footer";
import Home from "./pages/Home/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import NotFound from "./pages/NotFound/NotFound";
import Research from "./pages/Research/Research";
// import Blog from "./pages/Blog/Blog";
// import BlogArticle from "./pages/BlogArticle/BlogArticle";
import AGIForTheEarth from "./pages/ResearchArticle/AGIForTheEarth";
import SeeFar from "./pages/ResearchArticle/SeeFar";
import { ThemeProvider } from "./context/ThemeContext";
import ScrollToTop from "./components/common/ScrollToTop/ScrollToTop";
import Theme from "./components/common/Theme/Theme";

function App() {
  const CLOUDFRONT_URL = "https://d1i7a4tvmq5n6e.cloudfront.net";

  return ( 
    <ThemeProvider>
      <div className="app">
        <Theme />
        <Header CLOUDFRONT_URL={CLOUDFRONT_URL} />
        <div className="app__content">
          <ScrollToTop />
          <Routes>
            <Route
              path="*"
              element={<NotFound CLOUDFRONT_URL={CLOUDFRONT_URL} />}
            />
            <Route
              path="/"
              element={<Home CLOUDFRONT_URL={CLOUDFRONT_URL} />}
            />
            <Route
              path="/research"
              element={<Research CLOUDFRONT_URL={CLOUDFRONT_URL} />}
            />
            <Route
              path="/research/agi-for-the-earth"
              element={<AGIForTheEarth CLOUDFRONT_URL={CLOUDFRONT_URL} />}
            />
            <Route
              path="/research/seefar"
              element={<SeeFar CLOUDFRONT_URL={CLOUDFRONT_URL} />}
            />
            {/* <Route
              path="/blog"
              element={<Blog CLOUDFRONT_URL={CLOUDFRONT_URL} />}
            />
            <Route
              path="/blog/article"
              element={<BlogArticle CLOUDFRONT_URL={CLOUDFRONT_URL} />}
            /> */}
            <Route path="/privacy-policy" element={<PrivacyPolicy CLOUDFRONT_URL={CLOUDFRONT_URL} />} />
          </Routes>
        </div>
        <Footer CLOUDFRONT_URL={CLOUDFRONT_URL} />
      </div>
    </ThemeProvider>
  );
}

export default function Root() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
